// extracted by mini-css-extract-plugin
module.exports = {"main":"posts--main--1eq1u","totalCount":"posts--totalCount--25RVJ","posts":"posts--posts--3yQbx"};